import Icon from '@/components/ui/AppIcon';

interface StatCardProps {
  value: string;
  label: string;
  icon: string;
  delay?: string;
}

function StatCard({ value, label, icon, delay }: StatCardProps) {
  return (
    <div className="text-center reveal" style={{ animationDelay: delay }}>
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary/10 mb-4">
        <Icon name={icon as any} size={32} className="text-primary" />
      </div>
      <div className="text-5xl md:text-6xl font-bold text-foreground mb-2">{value}</div>
      <div className="text-base text-muted-foreground">{label}</div>
    </div>);

}

export default function ImpactSection() {
  const stats = [
  {
    id: 'stat_1',
    value: '40+',
    label: 'Years of European Feed Expertise',
    icon: 'AcademicCapIcon'
  },
  {
    id: 'stat_2',
    value: '250+',
    label: 'Ugandan Families Served',
    icon: 'UserGroupIcon'
  },
  {
    id: 'stat_3',
    value: '10–15%',
    label: 'Increase in Egg Production',
    icon: 'ChartBarIcon'
  },
  {
    id: 'stat_4',
    value: '100%',
    label: 'Dutch Quality Standards',
    icon: 'ShieldCheckIcon'
  }];


  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16 reveal">
          <p className="text-primary font-bold uppercase tracking-wider text-sm mb-4">Our Impact</p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-tight text-foreground">
            Delivering measurable results for <br />
            <span className="gradient-text">Ugandan farmers</span>
          </h2>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {stats.map((stat, index) =>
          <StatCard
            key={stat.id}
            value={stat.value}
            label={stat.label}
            icon={stat.icon}
            delay={`${index * 0.1}s`} />

          )}
        </div>

        {/* Featured Impact Image */}
        <div className="relative rounded-3xl overflow-hidden shadow-2xl reveal" style={{ animationDelay: '0.4s' }}>
          <div className="aspect-[21/9] bg-gradient-to-br from-green-100 to-green-50">
            <img
              src="https://img.rocket.new/generatedImages/rocket_gen_img_1c6bc3f27-1770040084525.png"
              alt="Large-scale commercial poultry farm showing rows of healthy chickens in modern climate-controlled facility"
              className="w-full h-full object-cover" />
            
          </div>
        </div>
      </div>
    </section>);

}